module.exports = __webpack_public_path__ + "img/cssk.e8b364fe.png";